import { render, staticRenderFns } from "./VipMembershipCard.vue?vue&type=template&id=991542a0&scoped=true"
import script from "./VipMembershipCard.vue?vue&type=script&lang=js"
export * from "./VipMembershipCard.vue?vue&type=script&lang=js"
import style0 from "./VipMembershipCard.vue?vue&type=style&index=0&id=991542a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "991542a0",
  null
  
)

export default component.exports